import types from './actionTypes';
import Requester from "../blueprint/svc";
import { invokePostService } from '../global/actions'
const fetch = new Requester();


export const addSection = (item, parentID, index) => {
   return ({ type: types.ADD_ITEM_TO_SCHEMA, payload: { item, parentID, index } })
}

export const updateSectionSchema = (section, parentID) => {
   return ({ type: types.UPDATE_SECTION_SCHEMA, payload: { section, parentID } })
}

export const addUISchema = (section) => {
   return ({ type: types.ADD_UI_SCHEMA, payload: { section } })
}

export const updateUISchema = (section) => {
   return ({ type: types.UPDATE_UI_SCHEMA, payload: { section } })
}

export const deleteSectionSchema = (section, parentId) => {
   return ({ type: types.DELETE_SECTION_SCHEMA, payload: { section, parentId } })
}

export const addFieldSchema = (payload) => {
   return ({ type: types.ADD_FIELD_SCHEMA, payload })
}

export const updateFieldSchema = (payload) => {
   return ({ type: types.UPDATE_FIELD_SCHEMA, payload })
}

export const resetView = () => {
   return async (dispatch, getState) => {
     dispatch({ type: types.RESET_VIEW });
     return Promise.resolve();
   };
 };

export const addView = (payload) => {
   return ({ type: types.ADD_VIEW, payload })
}


export const deleteView = (payload) => (dispatch,getState) => {
   return dispatch(invokePostService('deleteView',{}, [ payload._id]))
}

export const updateCompleteViews = (payload) => {
   return ({ type: types.UPDATE_COMPLETE_VIEWS, payload })

}

export const updateFullView = (payload) => {
   return ({ type: types.UPDATE_FULL_VIEWS, payload })
}

export const generateDemoData = (schema, key, docId) => async (dispatch, getState) => {

   try {

      const { status, data } = await fetch.post(fetch.route.generateDemodata, {schema, key, docId});
      return { status, data };
   }


   catch (error) {
      return { staus: false, data: null }
   }

}

export const saveView = () => async (dispatch,getState) => {
      const view = getState().schema[0];
      
      if(view === undefined) {
         alert('Invalid view')
         return
      }

     const response = await dispatch(invokePostService('updateView',{view}, [view._id]));
     return response;

}



export const setView = (payload) => {
   return ({ type: types.SET_VIEW, payload })
}

export const editView = (payload) => {
   return ({ type: types.EDIT_VIEW, payload })
}

export const interruptViewAction = () => {
   return ({ type: types.SET_VIEW_INTERRUPT })
}